import React from 'react';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import InnerHTML from '@Components/InnerHTML';

export default class DataCell extends React.PureComponent {

  render() {
    const { data } = this.props;
    const value = data && isArray(data) ? data.join(', ') : data;

    return value ? <InnerHTML tag="div" html={value} /> : null;
  }
}

DataCell.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]).isRequired,
};
